<template>
  <div
    v-if="globals.statusMessage && globals.statusMessage.active"
    class="statusbar"
  >
    <div class="statusbar--message">
      <q-icon
        class="tw-mt-1 tw-shrink-0 sm:tw-mt-0"
        color="warning"
        :name="toClassicIcon('fa-info-circle', 'solid')"
      />

      <!-- The message is rich text sanitised server-side by RichTextHandler. -->
      <div class="statusbar--content" v-html="globals.statusMessage.message" />
    </div>

    <c-button-icon
      class="tw-shrink-0"
      color="transparent"
      text-color="primary"
      size="12px"
      :icon="toClassicIcon('fa-times', 'solid')"
      rounded
      @click="globals.statusMessage.active = false"
    />
  </div>
</template>

<script setup>
import { toClassicIcon } from "common/defaultIcons";
import { storeToRefs } from "pinia";
import { useGlobalStore } from "stores/global/global";
import { onMounted } from "vue";

// Store
const globalStore = useGlobalStore();
const { globals } = storeToRefs(globalStore);
const { getStatusMessage } = globalStore;

onMounted(async () => {
  if (
    globals.value.statusMessage &&
    globals.value.statusMessage.message === null
  ) {
    await getStatusMessage();
  }
});
</script>

<style lang="scss">
.statusbar {
  @apply tw-flex tw-min-h-[40px] tw-items-start tw-gap-2 tw-border-b tw-border-alert-warning tw-px-4 tw-py-2 sm:tw-items-center;

  // Same recipe as the warning variant of CBanner: tint the semantic token
  // instead of hard-coding the resulting hex.
  background: color-mix(in srgb, rgb(var(--color-alert-warning)) 40%, white);

  &--message {
    @apply tw-flex tw-min-w-0 tw-flex-1 tw-items-start tw-gap-2 tw-text-sm sm:tw-items-center sm:tw-justify-center sm:tw-text-base;
  }

  &--content {
    @apply tw-min-w-0 tw-break-words;

    p {
      @apply tw-m-0;
    }

    p + p {
      @apply tw-mt-1;
    }
  }
}
</style>
